/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    DisableExtendedVersioningSettingsRequest,
    DisableExtendedVersioningSettingsRequestFromJSON,
    DisableExtendedVersioningSettingsRequestFromJSONTyped,
    DisableExtendedVersioningSettingsRequestToJSON,
} from './DisableExtendedVersioningSettingsRequest';

/**
 * 
 * @export
 * @interface UpgradeRuleRequest
 */
export interface UpgradeRuleRequest {
    /**
     * 
     * @type {string}
     * @memberof UpgradeRuleRequest
     */
    deviceTypeId?: string;
    /**
     * 
     * @type {string}
     * @memberof UpgradeRuleRequest
     */
    superGroupId?: string;
    /**
     * 
     * @type {string}
     * @memberof UpgradeRuleRequest
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpgradeRuleRequest
     */
    loaderVersionFirmwareId?: string;
    /**
     * 
     * @type {string}
     * @memberof UpgradeRuleRequest
     */
    fwVersionFirmwareId?: string;
    /**
     * 
     * @type {string}
     * @memberof UpgradeRuleRequest
     */
    uiVersionFirmwareId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpgradeRuleRequest
     */
    forceUpdate?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpgradeRuleRequest
     */
    sendAllFirmwares?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof UpgradeRuleRequest
     */
    customFirmware1VersionId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpgradeRuleRequest
     */
    customFirmware2VersionId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpgradeRuleRequest
     */
    customFirmware3VersionId?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpgradeRuleRequest
     */
    enableLoaderCondition?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpgradeRuleRequest
     */
    minLoaderVersion?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpgradeRuleRequest
     */
    maxLoaderVersion?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpgradeRuleRequest
     */
    enableFwCondition?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpgradeRuleRequest
     */
    minFwVersion?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpgradeRuleRequest
     */
    maxFwVersion?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpgradeRuleRequest
     */
    enableUiCondition?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpgradeRuleRequest
     */
    minUiVersion?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpgradeRuleRequest
     */
    maxUiVersion?: string | null;
    /**
     * 
     * @type {DisableExtendedVersioningSettingsRequest}
     * @memberof UpgradeRuleRequest
     */
    disableExtendedVersioningSettings?: DisableExtendedVersioningSettingsRequest | null;
}

export function UpgradeRuleRequestFromJSON(json: any): UpgradeRuleRequest {
    return UpgradeRuleRequestFromJSONTyped(json, false);
}

export function UpgradeRuleRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpgradeRuleRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'deviceTypeId': !exists(json, 'deviceTypeId') ? undefined : json['deviceTypeId'],
        'superGroupId': !exists(json, 'superGroupId') ? undefined : json['superGroupId'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'loaderVersionFirmwareId': !exists(json, 'loaderVersionFirmwareId') ? undefined : json['loaderVersionFirmwareId'],
        'fwVersionFirmwareId': !exists(json, 'fwVersionFirmwareId') ? undefined : json['fwVersionFirmwareId'],
        'uiVersionFirmwareId': !exists(json, 'uiVersionFirmwareId') ? undefined : json['uiVersionFirmwareId'],
        'forceUpdate': !exists(json, 'forceUpdate') ? undefined : json['forceUpdate'],
        'sendAllFirmwares': !exists(json, 'sendAllFirmwares') ? undefined : json['sendAllFirmwares'],
        'customFirmware1VersionId': !exists(json, 'customFirmware1VersionId') ? undefined : json['customFirmware1VersionId'],
        'customFirmware2VersionId': !exists(json, 'customFirmware2VersionId') ? undefined : json['customFirmware2VersionId'],
        'customFirmware3VersionId': !exists(json, 'customFirmware3VersionId') ? undefined : json['customFirmware3VersionId'],
        'enableLoaderCondition': !exists(json, 'enableLoaderCondition') ? undefined : json['enableLoaderCondition'],
        'minLoaderVersion': !exists(json, 'minLoaderVersion') ? undefined : json['minLoaderVersion'],
        'maxLoaderVersion': !exists(json, 'maxLoaderVersion') ? undefined : json['maxLoaderVersion'],
        'enableFwCondition': !exists(json, 'enableFwCondition') ? undefined : json['enableFwCondition'],
        'minFwVersion': !exists(json, 'minFwVersion') ? undefined : json['minFwVersion'],
        'maxFwVersion': !exists(json, 'maxFwVersion') ? undefined : json['maxFwVersion'],
        'enableUiCondition': !exists(json, 'enableUiCondition') ? undefined : json['enableUiCondition'],
        'minUiVersion': !exists(json, 'minUiVersion') ? undefined : json['minUiVersion'],
        'maxUiVersion': !exists(json, 'maxUiVersion') ? undefined : json['maxUiVersion'],
        'disableExtendedVersioningSettings': !exists(json, 'disableExtendedVersioningSettings') ? undefined : DisableExtendedVersioningSettingsRequestFromJSON(json['disableExtendedVersioningSettings']),
    };
}

export function UpgradeRuleRequestToJSON(value?: UpgradeRuleRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'deviceTypeId': value.deviceTypeId,
        'superGroupId': value.superGroupId,
        'name': value.name,
        'loaderVersionFirmwareId': value.loaderVersionFirmwareId,
        'fwVersionFirmwareId': value.fwVersionFirmwareId,
        'uiVersionFirmwareId': value.uiVersionFirmwareId,
        'forceUpdate': value.forceUpdate,
        'sendAllFirmwares': value.sendAllFirmwares,
        'customFirmware1VersionId': value.customFirmware1VersionId,
        'customFirmware2VersionId': value.customFirmware2VersionId,
        'customFirmware3VersionId': value.customFirmware3VersionId,
        'enableLoaderCondition': value.enableLoaderCondition,
        'minLoaderVersion': value.minLoaderVersion,
        'maxLoaderVersion': value.maxLoaderVersion,
        'enableFwCondition': value.enableFwCondition,
        'minFwVersion': value.minFwVersion,
        'maxFwVersion': value.maxFwVersion,
        'enableUiCondition': value.enableUiCondition,
        'minUiVersion': value.minUiVersion,
        'maxUiVersion': value.maxUiVersion,
        'disableExtendedVersioningSettings': DisableExtendedVersioningSettingsRequestToJSON(value.disableExtendedVersioningSettings),
    };
}

